"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const glint_canvas_1 = require("./glint-canvas");
const trippy_waves_glsl_1 = __importDefault(require("./assets/shaders/trippy-waves.glsl"));
const cool_effect_glsl_1 = __importDefault(require("./assets/shaders/cool-effect.glsl"));
const default_shader_glsl_1 = __importDefault(require("./assets/shaders/default-shader.glsl"));
const stars_glsl_1 = __importDefault(require("./assets/shaders/stars.glsl"));
const circles_glsl_1 = __importDefault(require("./assets/shaders/circles.glsl"));
const color_gradients_glsl_1 = __importDefault(require("./assets/shaders/color-gradients.glsl"));
const circle_glow_glsl_1 = __importDefault(require("./assets/shaders/circle-glow.glsl"));
const domain_warping_shader_glsl_1 = __importDefault(require("./assets/shaders/domain-warping-shader.glsl"));
const shaders = {
    lensing: cool_effect_glsl_1.default,
    trippyWaves: trippy_waves_glsl_1.default,
    defaultShader: default_shader_glsl_1.default,
    stars: stars_glsl_1.default,
    colorGradients: color_gradients_glsl_1.default,
    circles: circles_glsl_1.default,
    circleGlow: circle_glow_glsl_1.default,
    domainWarpingShader: domain_warping_shader_glsl_1.default
};
(function setupCopyButtons() {
    document.querySelectorAll(".copy-btn:not([data-shader]").forEach(btn => {
        btn.addEventListener("click", () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const code = (_c = (_b = (_a = btn.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector("code")) === null || _b === void 0 ? void 0 : _b.textContent) !== null && _c !== void 0 ? _c : "";
            yield navigator.clipboard.writeText(code);
            btn.textContent = "Copied!";
            setTimeout(() => {
                btn.textContent = "Copy";
            }, 1500);
        }));
    });
    document.querySelectorAll("[data-shader]").forEach(btn => {
        btn.addEventListener("click", () => __awaiter(this, void 0, void 0, function* () {
            const name = btn.getAttribute("data-shader");
            yield navigator.clipboard.writeText(shaders[name]);
            btn.textContent = "Copied!";
            setTimeout(() => btn.textContent = "Copy Shader", 1500);
        }));
    });
})();
(function setupFeatureGradients() {
    const colorGradCanvases = document.querySelectorAll(".color-grad");
    const colorGradTargets = document.querySelectorAll(".color-grad-target");
    for (let i = 0; i < colorGradCanvases.length; i++) {
        const canvas = colorGradCanvases[i];
        const target = colorGradTargets[i];
        const glint = new glint_canvas_1.GlintCanvas({
            element: canvas,
            fragmentSource: color_gradients_glsl_1.default,
            targetElement: target,
            uniforms: [
                { name: 'uColorCycle', value: i + 1 }
            ],
        });
        glint.startRender();
    }
})();
(function setupExampleShaders() {
    const defaultTarget = document.querySelector("#default-shader");
    const defaultEl = defaultTarget.querySelector("canvas");
    const glintDefault = new glint_canvas_1.GlintCanvas({
        element: defaultEl,
        targetElement: defaultTarget,
        fragmentSource: default_shader_glsl_1.default,
        fps: 1,
        mobileFps: 1
    });
    glintDefault.startRender();
    const trippyWavesTarget = document.querySelector("#trippy-waves");
    const trippyWavesEl = trippyWavesTarget.querySelector("canvas");
    const glintWaves = new glint_canvas_1.GlintCanvas({
        element: trippyWavesEl,
        targetElement: trippyWavesTarget,
        fragmentSource: trippy_waves_glsl_1.default,
        pulseSpeed: 3
    });
    glintWaves.startRender();
    const lensingTarget = document.querySelector("#lensing");
    const lensingEl = lensingTarget.querySelector("canvas");
    const glintLensing = new glint_canvas_1.GlintCanvas({
        element: lensingEl,
        targetElement: lensingTarget,
        fragmentSource: cool_effect_glsl_1.default,
        scaleModifier: new glint_canvas_1.Vector2(2, 2),
        pulseSpeed: 3
    });
    glintLensing.startRender();
    const starsTarget = document.querySelector("#stars");
    const starsEl = starsTarget.querySelector("canvas");
    const glintStars = new glint_canvas_1.GlintCanvas({
        element: starsEl,
        targetElement: starsTarget,
        fragmentSource: stars_glsl_1.default,
        scaleModifier: new glint_canvas_1.Vector2(8, 8)
    });
    glintStars.startRender();
    const circlesTarget = document.querySelector("#circles");
    const circlesEl = circlesTarget.querySelector("canvas");
    const glintCircles = new glint_canvas_1.GlintCanvas({
        element: circlesEl,
        targetElement: circlesTarget,
        fragmentSource: circles_glsl_1.default,
        uniforms: [
            { name: "uColorCycle", value: 6.31 }
        ]
    });
    glintCircles.startRender();
    const colorGadientTarget = document.querySelector("#color-gradient");
    const colorGadient = colorGadientTarget.querySelector("canvas");
    const glintColorGradient = new glint_canvas_1.GlintCanvas({
        element: colorGadient,
        targetElement: colorGadientTarget,
        fragmentSource: color_gradients_glsl_1.default,
        uniforms: [
            { name: 'uColorCycle', value: 6 }
        ],
    });
    glintColorGradient.startRender();
    const backgroundCanvas = document.querySelector("#background");
    const backgroundTarget = document.body;
    const glintBackground = new glint_canvas_1.GlintCanvas({
        element: backgroundCanvas,
        targetElement: backgroundTarget,
        fragmentSource: stars_glsl_1.default,
        zIndex: -2,
        maxPixelRatio: 1,
        uniforms: [
            { name: 'uStarAmount', value: 2 }
        ],
        onUpdate: (canvas, time, delta) => {
            const isMobile = window.innerWidth < 768;
            canvas.additionalUniforms[0].value = isMobile ? 3 : 1;
        }
    });
    glintBackground.startRender();
    const codeBlocks = document.querySelectorAll(".code-block");
    for (let i = 0; i < codeBlocks.length; i++) {
        const target = codeBlocks[i];
        const canvas = target.querySelector("canvas");
        const glint = new glint_canvas_1.GlintCanvas({
            element: canvas,
            targetElement: target,
            fragmentSource: circle_glow_glsl_1.default,
            uniforms: [
                { name: "uCycle", value: i + 1 }
            ]
        });
        glint.startRender();
    }
    const h1Target = document.querySelector("h1");
    const h1Canvas = document.querySelector("#h1canvas");
    const h1C = new glint_canvas_1.GlintCanvas({
        element: h1Canvas,
        targetElement: h1Target,
        fragmentSource: domain_warping_shader_glsl_1.default,
        zIndex: 1,
        webglVersion: "webgl2",
        mobileFps: 24,
        uniforms: [
            { name: 'uMaxIterations', value: 3 }
        ],
        onUpdate: (canvas, time, delta) => {
            const isMobile = window.innerWidth < 768;
            canvas.additionalUniforms[0].value = isMobile ? 1 : 3;
        }
    });
    h1C.startRender();
    const domainWarpingTarget = document.querySelector("#domain-warping-shader");
    const domainWarpingCanvas = domainWarpingTarget.querySelector("canvas");
    const domainWarping = new glint_canvas_1.GlintCanvas({
        element: domainWarpingCanvas,
        targetElement: domainWarpingTarget,
        fragmentSource: domain_warping_shader_glsl_1.default,
        zIndex: 1,
        webglVersion: "webgl2",
        mobileFps: 24,
        uniforms: [
            { name: 'uMaxIterations', value: 1 }
        ],
        onUpdate: (canvas, time, delta) => {
            const isMobile = window.innerWidth < 768;
            canvas.additionalUniforms[0].value = isMobile ? 1 : 3;
        }
    });
    domainWarping.startRender();
})();
